import moment from 'moment-timezone';

const getEventMoment = (dateTime, timezone) => {
  if (!dateTime) {
    return null;
  }

  if (moment.isMoment(dateTime)) {
    return timezone ? dateTime.clone().tz(timezone) : dateTime.clone();
  }

  return timezone ? moment.tz(dateTime, timezone) : moment(dateTime);
};

const parseEventDateTime = (dateString, timeString, timezone, format='ddd MMM DD YYYY h:mm A') => {
  if (!dateString || !timeString) {
    return null;
  }

  const value = `${dateString} ${timeString}`;

  return timezone ? moment.tz(value, format, timezone) : moment(value, format);
};

const formatEventDate = (dateTime, timezone, format='dddd, MMMM D, YYYY') => {
  const eventMoment = getEventMoment(dateTime, timezone);

  return eventMoment ? eventMoment.format(format) : '';
};

const formatEventDateTime = (dateTime, timezone, format='LLL z') => {
  const eventMoment = getEventMoment(dateTime, timezone);

  return eventMoment ? eventMoment.format(format) : '';
};

const formatEventTime = (dateTime, timezone, format='h:mm A z') => {
  const eventMoment = getEventMoment(dateTime, timezone);

  return eventMoment ? eventMoment.format(format) : '';
};

const getEventTimezoneAbbr = (dateTime, timezone) => {
  const eventMoment = getEventMoment(dateTime, timezone);

  return eventMoment ? eventMoment.format('z') : '';
};

const formatEventTimezone = (dateTime, timezone) => {
  const eventMoment = getEventMoment(dateTime, timezone);

  if (!eventMoment) {
    return timezone || '';
  }

  return `${timezone} (${eventMoment.format('z')})`;
};

export {
  formatEventDate,
  formatEventDateTime,
  formatEventTime,
  getEventTimezoneAbbr,
  formatEventTimezone,
  getEventMoment,
  parseEventDateTime,
};
